import { StyleSheet, View, ViewProps } from 'react-native'
import { startOfYesterday } from 'date-fns'
import {
  DatePicker,
  DatePickerPresetConfig,
  Spacing,
  Switch,
  Text,
  Color,
  Radius,
  CalendarValue,
  datePresets,
  Weekday,
  AllWeekdays,
} from 'zens-storybook'
import { Trans, useTranslation } from 'react-i18next'
import { CompanyWorkHours, useStore } from 'zens-store'

import Weekdays from './weekdays'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'flex-end',
  },
  content: {
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    borderWidth: 1,
    borderColor: Color.calmGrey,
    shadowOffset: {
      width: 1,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 30,
    shadowColor: Color.premiumBlack,
  },
  switch: {
    flex: 1,
    marginVertical: Spacing.XS,
  },
  preferences: {
    marginTop: Spacing.M,
    minWidth: 280,
    marginHorizontal: Spacing.S,
  },
  help: {
    maxWidth: 198,
    color: Color.simplyWhite,
  },
  weekdays: {
    marginVertical: Spacing.XS,
  },
})

interface Props extends ViewProps {
  workHours?: CompanyWorkHours
  period?: CalendarValue
  onChangePeriod?: (value: CalendarValue) => void
  workingHours?: boolean
  onChangeWorkingHours?: (workingHours: boolean) => void
  weekdays?: Weekday[]
  onChangeWeekdays?: (weekdays: Weekday[]) => void
}

const InsightsCalendar = (props: Props) => {
  const {
    workHours,
    period,
    onChangePeriod,
    workingHours,
    onChangeWorkingHours,
    weekdays,
    onChangeWeekdays,
    style,
    ...otherProps
  } = props
  const { t } = useTranslation()
  const { i18n } = useStore()

  // FIXME: Temperarily disable insigights for today
  // const today = startOfToday()
  const yesterday = startOfYesterday()

  const preset = {
    items: datePresets(t),
    otherItemTitle: t('Custom'),
    extra: (
      <View style={styles.preferences}>
        <Text level={5}>
          <Trans>Preferences</Trans>
        </Text>
        <Weekdays
          style={styles.weekdays}
          helpStyle={styles.help}
          value={weekdays}
          onSelect={onChangeWeekdays}
          unfoldOnPressOutside={false}
        />
        <Switch
          label={t('Show working hours only')}
          style={styles.switch}
          help={
            <Text style={styles.help}>
              {t('Only activity between {{startWorkday}} and {{endWorkday}} will be taken into account.', {
                startWorkday: workHours?.startAt,
                endWorkday: workHours?.endAt,
              })}
            </Text>
          }
          value={workingHours}
          onValueChange={onChangeWorkingHours}
          testID="InsightsCalendar.WorkingHours"
        />
      </View>
    ),
  } as DatePickerPresetConfig
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.content}>
        <DatePicker
          invalidDateText={t('Invalid date')}
          preset={preset}
          disabled={{
            // FIXME: Temperarily disable insigights for today
            // after: today,
            after: yesterday,
            weekdays: AllWeekdays.filter((value) => weekdays && weekdays.indexOf(value) < 0),
          }}
          value={period}
          onValueChange={onChangePeriod}
          language={i18n.language}
        />
      </View>
    </View>
  )
}

export default InsightsCalendar
